import { html } from 'lit';
import type { LandingContent } from '../../shared/content/landingContent.js';
import { editorSemanticText } from '../editor/editorSemanticText.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

export const globusPartnerSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => {
  const partner = content.globusPartner;

  return html`
    <section
      class=${editorNodeClass(editor, 'section.globusPartner', 'vp-section vp-globus-section')}
      style=${editorNodeStyle(editor, 'section.globusPartner')}
      @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.globusPartner', event)}
      @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.globusPartner', event)}
    >
      <div
        class=${editorNodeClass(editor, 'globusPartner.layout', 'vp-shell vp-globus-layout')}
        style=${editorNodeStyle(editor, 'globusPartner.layout')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'globusPartner.layout', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'globusPartner.layout', event)}
      >
        <div
          class=${editorNodeClass(editor, 'globusPartner.logoPanel', 'vp-globus-logo-panel reveal-card')}
          style=${editorNodeStyle(editor, 'globusPartner.logoPanel')}
          @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'globusPartner.logoPanel', event)}
          @click=${(event: MouseEvent) => editorNodeClick(editor, 'globusPartner.logoPanel', event)}
        >
          <img
            class=${editorNodeClass(editor, 'globusPartner.image', 'vp-globus-partner-image')}
            style=${editorNodeStyle(editor, 'globusPartner.image')}
            src=${partner.image}
            alt=${partner.imageAlt}
            width="1200"
            height="1600"
            loading="lazy"
            decoding="async"
            @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'globusPartner.image', event)}
            @click=${(event: MouseEvent) => editorNodeClick(editor, 'globusPartner.image', event)}
          />
          <img
            class=${editorNodeClass(editor, 'globusPartner.logo', 'vp-globus-logo')}
            style=${editorNodeStyle(editor, 'globusPartner.logo')}
            src=${partner.logo}
            alt=${partner.logoAlt}
            decoding="async"
            loading="lazy"
            @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'globusPartner.logo', event)}
            @click=${(event: MouseEvent) => editorNodeClick(editor, 'globusPartner.logo', event)}
          />
        </div>
        <div
          class=${editorNodeClass(editor, 'globusPartner.copy', 'vp-globus-copy')}
          style=${editorNodeStyle(editor, 'globusPartner.copy')}
          @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'globusPartner.copy', event)}
          @click=${(event: MouseEvent) => editorNodeClick(editor, 'globusPartner.copy', event)}
        >
          ${editorSemanticText({ editor, elementId: 'globusPartner.title', fallbackTag: 'h2', content: partner.title })}
          ${editorSemanticText({
            editor,
            elementId: 'globusPartner.text',
            fallbackTag: 'p',
            className: 'vp-globus-text',
            content: partner.text,
          })}
          <a
            class=${editorNodeClass(editor, 'globusPartner.primaryAction.label', 'vp-action vp-action-primary')}
            style=${editorNodeStyle(editor, 'globusPartner.primaryAction.label')}
            href=${partner.primaryAction.href}
            @pointerdown=${(event: PointerEvent) =>
              editorNodePointerDown(editor, 'globusPartner.primaryAction.label', event)}
            @click=${(event: MouseEvent) => editorNodeClick(editor, 'globusPartner.primaryAction.label', event)}
          >
            ${partner.primaryAction.label}
          </a>
        </div>
      </div>
    </section>
  `;
};
